export const UPDATE_DOMAINS_REQUEST = 'UPDATE_DOMAINS_REQUEST';
export const UPDATE_DOMAINS_SUCCESS = 'UPDATE_DOMAINS_SUCCESS';
export const UPDATE_DOMAINS_PARTIAL_SUCCESS = 'UPDATE_DOMAINS_PARTIAL_SUCCESS';
export const UPDATE_DOMAINS_FAILURE = 'UPDATE_DOMAINS_FAILURE';
